import { filterRequest } from 'rxOperators/filterRequestOfType'
import { mergeMapAsync } from 'rxOperators/mergeMapAsync'
import { EpicRefined } from 'interfaces/middleware'
import { CCOnboardingActions, GetCCShipmentAddressAction } from 'components/features/creditCard/creditCardStore/actions'
import { gqlCCShipmentAddressQuery } from 'queries/shipmentAddressQuery'


export const ccShipmentAddressEpic: EpicRefined<CCOnboardingActions> = (action$) => action$.pipe(
  filterRequest(GetCCShipmentAddressAction.type),
  mergeMapAsync(async (action) => {
    try {
      const result = await gqlCCShipmentAddressQuery()
      console.log('ccShipmentAddressEpic', { result })
      if (!result.error) {
        console.log('ccShipmentAddressEpic success', { result })
        return action.success(result.data.current_user.shipment_address)
      }
      console.log('ccShipmentAddressEpic fail', { result })

      return action.fail({ errorCode: 400 })
    } catch (e) {
      console.log('ccShipmentAddressEpic exception', { e })

      return action.fail({ errorCode: 400 })
    }
  }),
)
